import $ from 'jquery';

const defaults = {
  links: '.link-related',
  title: 'Our Services',
};

function DropdownWrapper(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.init();
}

DropdownWrapper.prototype = {
  init() {
    this.$element.find(this.settings.links).wrapAll('<li class="dropdown"><div class="dropdown-wrapper"><ul class="dropdown-list">');
    this.$element.find('.dropdown-wrapper').prepend(`<span class="dropdown-clickable">${this.settings.title}</span>`);
  },
};

export default DropdownWrapper;



// WEBPACK FOOTER //
// ./DropdownWrapper.js